import React, { useState } from 'react';
import {
  TextField,
  Button,
  Box,
  InputAdornment,
} from '@mui/material';

const MobileNumberInput = ({ onSubmit }) => {
  const [mobileNumber, setMobileNumber] = useState('');
  const [error, setError] = useState('');

  const validateMobileNumber = (number) => {
    // Validation for mobile number with country code
    const mobileRegex = /^\+?[1-9]\d{1,14}$/;
    return mobileRegex.test(number);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!mobileNumber) {
      setError('Mobile number is required');
      return;
    }
    if (!validateMobileNumber(mobileNumber)) {
      setError('Please enter a valid mobile number with country code (e.g., +91XXXXXXXXXX)');
      return;
    }
    setError('');
    onSubmit(mobileNumber);
  };

  const handleChange = (e) => {
    const value = e.target.value;
    // Allow numbers and + at the start
    if (value === '' || /^\+?[0-9]+$/.test(value)) {
      setMobileNumber(value);
      setError('');
    }
  };

  return (
    <Box component="form" onSubmit={handleSubmit} noValidate>
      <TextField
        margin="normal"
        required
        fullWidth
        id="mobileNumber"
        label="Mobile Number"
        name="mobileNumber"
        autoComplete="tel"
        autoFocus
        value={mobileNumber}
        onChange={handleChange}
        error={!!error}
        helperText={error}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              +91
            </InputAdornment>
          ),
        }}
        inputProps={{
          maxLength: 15,
          pattern: '[0-9]*',
        }}
      />
      <Button
        type="submit"
        fullWidth
        variant="contained"
        sx={{ mt: 3, mb: 2 }}
      >
        Continue
      </Button>
    </Box>
  );
};

export default MobileNumberInput; 